export const ReCaptcha_Site_Key = "6LeQLzgmAAAAAPeV0c_Mbo1VxOfxpaaJiBnZOIxu";
export const ReCaptcha_Secret_Key = "6LeQLzgmAAAAAApyO4PAk9OQCgb_u2mAOAeO1_ou";
